import KfzList from "../components/KfzList";
import {connect} from "react-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_KFZ_FETCH} from "../actions";
import {isOnline} from "../actions/userActions";
import {fetchKfzList} from "../actions/kfzActions";
import {push} from "react-router-redux";

const m2s = state => ({
	isLoading: isProcessing(state, PROC_KFZ_FETCH),
	kfz_list: state.kfz.list
});

const m2d = dispatch => {
	dispatch(isOnline(() => {
		dispatch(fetchKfzList());
	}));
	return {
		onLoad: (kfz_id = null, force=false, onSuccess) => dispatch(fetchKfzList(kfz_id, force, onSuccess)),
		push: to => dispatch(push(to))
	};
};

export default connect(m2s, m2d)(KfzList);


// WEBPACK FOOTER //
// ./src/containers/KfzListController.js